/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseTrianglesHClosedIcon16Solid = forwardRef('ArrowCollapseTrianglesHClosedIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "m3.28 3.78 3.336 3.336a1.25 1.25 0 0 1 0 1.768L3.28 12.22A.75.75 0 0 1 2 11.69V4.31a.75.75 0 0 1 1.28-.53Z" }),
        React.createElement("path", { d: "M12.72 3.78 9.384 7.116a1.25 1.25 0 0 0 0 1.768l3.336 3.336a.75.75 0 0 0 1.28-.53V4.31a.75.75 0 0 0-1.28-.53Z" })));
});
